<template>
  <v-data-table
    flat
    :headers="headers"
    :items="resources"
    class="elevation-2"
    :loading="isLoading"
    :total-items="resourcesCount"
    :rows-per-page-items="limitOptions"
    :pagination.sync="pagination"
  >
    <template slot="items" slot-scope="props">
      <td v-if="props.item.is_fee" class="is-fee">
        {{ dueDate(props.item.due_on) }}
      </td>
      <td v-else>{{ dueDate(props.item.due_on) }}</td>
      <td v-if="props.item.is_fee" class="text-xs-left is-fee">
        {{ diffDate(new Date(props.item.due_on)) }}
      </td>
      <td v-else class="text-xs-left">
        {{ diffDate(new Date(props.item.due_on)) }}
      </td>
      <td v-if="props.item.is_fee" class="text-xs-left is-fee">
        <router-link
          :to="{ name: 'payment', params: { id: props.item.payment_id } }"
        >
          {{ props.item.payment_uuid }}
        </router-link>
      </td>
      <td v-else class="text-xs-left">
        <router-link
          :to="{ name: 'payment', params: { id: props.item.payment_id } }"
        >
          {{ props.item.payment_uuid }}
        </router-link>
      </td>
      <td v-if="props.item.is_fee" class="text-xs-left is-fee">
        {{ $n("-" + props.item.amount, "currency") }}
      </td>
      <td v-else class="text-xs-left">
        {{ $n(props.item.amount, "currency") }}
      </td>
      <td v-if="props.item.is_fee" class="text-xs-left is-fee">
        <v-chip :class="setClass(props.item.status)" small text-color="white">
          {{ $t(`status.${props.item.status}`) }}
        </v-chip>
      </td>
      <td v-else class="text-xs-left">
        <v-chip :class="setClass(props.item.status)" small text-color="white">
          {{ $t(`status.${props.item.status}`) }}
        </v-chip>
      </td>
      <td v-if="props.item.is_fee" class="text-xs-left is-fee">
        {{ props.item.installments }}
      </td>
      <td v-else class="text-xs-left">{{ props.item.installments }}</td>
      <td class="text-xs-right">
        <payment-brand :brand="props.item.credit_card_brand" :size="32" />
      </td>
      <td class="text-xs-left">{{ props.item.authorization_code }}</td>
      <td class="text-xs-left">{{ props.item.nsu_acquirer }}</td>
    </template>
  </v-data-table>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { changed } from "@/helpers/layout";
import moment from "moment";

export default {
  mounted() {
    this.$store.dispatch("deposits/load");
  },
  computed: {
    ...mapGetters({
      resources: "deposits/resources",
      filters: "deposits/filter",
      isLoading: "deposits/loadingData",
      limitOptions: "deposits/limitOptions",
      resourcesCount: "deposits/resourcesCount",
    }),
  },
  methods: {
    ...mapActions({
      updateLimit: "deposits/updateLimit",
      updateCurrentPage: "deposits/updateCurrentPage",
    }),
    setChipColor(color) {
      return this.$t(`colors.${color}`);
    },
    setClass(status) {
      return `deposit ${status}`;
    },
    dueDate(dueOn) {
      return moment(dueOn).format("DD/MM/YYYY");
    },
    diffDate(depositDate) {
      const now = Date.now();
      const remainingDays = parseInt(
        (depositDate - now) / (1000 * 60 * 60 * 24),
        10
      );
      if (remainingDays > 0) {
        return remainingDays;
      }
      return 0;
    },
  },
  watch: {
    pagination: function pagination(newPagination, oldPagination) {
      if (changed(newPagination.rowsPerPage, oldPagination.rowsPerPage)) {
        this.updateLimit(newPagination.rowsPerPage);
        // this.$store.dispatch("deposits/load", this.filters);
      }
      if (changed(newPagination.page, oldPagination.page)) {
        this.updateCurrentPage(newPagination.page);
        // this.$store.dispatch("deposits/load", this.filters);
      }
    },
  },
  data() {
    return {
      items: [],
      pagination: {},
      headers: [
        { text: this.$t("phrases.depositDate"), value: "depositDate" },
        { text: this.$t("phrases.daysForDeposit"), value: "daysForDeposit" },
        { text: this.$t("phrases.forThePayment"), value: "forThePayment" },
        { text: this.$t("words.value"), value: "value" },
        { text: this.$t("status.status"), value: "status" },
        { text: this.$t("words.installment"), value: "installment" },
        { text: this.$t("words.cardBrand"), value: "cardBrand" },
        { text: this.$t("words.authorization"), value: "authorization_code" },
        { text: "nsu", value: "nsu_acquirer" },
      ],
    };
  },
  components: {
    PaymentBrand: () => import("@/components/desktop/brand/PaymentBrand.vue"),
  },
};
</script>
<style>
.v-chip.deposit.all {
  background-color: #757575 !important;
}
.v-chip.deposit.scheduled {
  background-color: #1565c0 !important;
}
.v-chip.deposit.processing {
  background-color: #546e7a !important;
}
.v-chip.deposit.cancelled {
  background-color: #b71c1c !important;
}
.v-chip.deposit.completed {
  background-color: #1b5e20 !important;
}
.v-chip.deposit.failed {
  background-color: #e53935 !important;
}
.v-chip.deposit.downed {
  background-color: #ef6c00 !important;
}
.v-chip.deposit.anticipated {
  background-color: #006064 !important;
}
.is-fee {
  color: rgb(255, 0, 0);
  font-weight: bold !important;
}
</style>
